import { useCallback, useMemo } from "react";

import { Counterparty } from "../../services";
import { isTextMatchingLeadingStarsFilterHelper } from "../../utils";

import { isQuery, isLimit } from ".";

const useCounterpartiesSubHandler = (): useCounterpartiesSubHandler.Props => {
	const getQueryAndLimitCounterpartiesSubHandler = useCallback(
		(
			{ limit, query }: useCounterpartiesSubHandler.SmallSubscribeOptions,
			roleSubscribe: Counterparty.Model[],
		): Counterparty.Model[] => {
			if (!Array.isArray(roleSubscribe)) {
				return [];
			}

			let retval = [...(roleSubscribe || [])];

			if (isQuery(query)) {
				retval = retval.filter(({ additionalFields, checks }) => {
					const name = additionalFields?.name ?? "";
					const edrpou = additionalFields?.edrpou ?? "";

					const isFindName = isTextMatchingLeadingStarsFilterHelper(
						name,
						query,
					);
					if (isFindName) return true;

					const isFindEdrpou = isTextMatchingLeadingStarsFilterHelper(
						edrpou,
						query,
					);
					if (isFindEdrpou) return true;

					return (
						checks?.some(({ additionalFields }) =>
							isTextMatchingLeadingStarsFilterHelper(
								additionalFields?.checkValue ?? "",
								query,
							),
						) ?? false
					);
				});
			}

			if (isLimit(limit)) {
				retval = retval.slice(0, limit);
			}

			return retval;
		},
		[],
	);

	return useMemo(
		() => ({
			getQueryAndLimitCounterpartiesSubHandler,
		}),
		[getQueryAndLimitCounterpartiesSubHandler],
	);
};

declare namespace useCounterpartiesSubHandler {
	interface Props {
		getQueryAndLimitCounterpartiesSubHandler: (
			data: SmallSubscribeOptions,
			roleSubscribe: Counterparty.Model[],
		) => Counterparty.Model[];
	}

	interface SmallSubscribeOptions {
		query?: string;
		limit?: number;
	}
}

export default useCounterpartiesSubHandler;
